import mathjaxDirective from './mathjax'
import katexDirective from './katex'

// 导出所有指令
export {
  mathjaxDirective,
  katexDirective
}

// 全局注册指令的函数
export function installDirectives(app, katexOptions) {
  app.directive('mathjax', mathjaxDirective)
  var vueKatexDirective = katexDirective(katexOptions);
  app.directive(vueKatexDirective.name, vueKatexDirective.directive)
}